/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Title_AccentInputs */

const en_auth_signup_title_accent = /** @type {(inputs: Auth_Signup_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`us.`)
};

const pl_auth_signup_title_accent = /** @type {(inputs: Auth_Signup_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nas.`)
};

/**
* | output |
* | --- |
* | "us." |
*
* @param {Auth_Signup_Title_AccentInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_signup_title_accent = /** @type {((inputs?: Auth_Signup_Title_AccentInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Title_AccentInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_signup_title_accent(inputs)
	return en_auth_signup_title_accent(inputs)
});